import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from '~/components/Money';
import Button from '~/components/ui/Button';
import { CardBox } from '~/components/ui/Card';
import Dialog from '~/components/ui/Dialog';
import Select, { SelectItem } from '~/components/ui/Select';
import Stack from '~/components/ui/Stack';
import useActiveSubscription from '~/modules/subscription/useActiveSubscription';
import useSubscriptionPlans from '~/modules/subscription/useSubscriptionPlans';
import useUpdateSubscription from '~/modules/subscription/useUpdateSubscription';

function SwitchPlanDialog() {
  const { t } = useTranslation('', { keyPrefix: 'subscription.switchPlanDialog' });
  const plans = useSubscriptionPlans();
  const { data: activePlan } = useActiveSubscription();
  const { mutateAsync, isPending } = useUpdateSubscription();
  const [selected, setSelected] = useState('');

  useEffect(() => {
    if (plans && plans?.length > 0) {
      setSelected(activePlan?.plan_id || plans[0].id);
    }
  }, [plans, activePlan]);

  const handleCreateSubscription = async (close: () => void) => {
    await mutateAsync(selected);
    close();
  };

  return (
    <Dialog className="sm:max-w-[460px]">
      {({ close }) => (
        <>
          <h2 className="text-center leading-10">{t('title')}</h2>
          <p className="text-center text-body text-sm">{t('description')}</p>

          <Stack col gap={8} className="mt-8">
            <Select
              label={t('selectLabel')}
              selectedKey={selected}
              onSelectionChange={(newValue) => setSelected(newValue?.toString() || '')}
            >
              {plans?.map((option) => (
                <SelectItem key={option.id} id={option.id} textValue={option.name}>
                  <div className="flex gap-2">
                    {t('planInfo', {
                      name: option.name,
                      duration: option.duration,
                      price: formatMoney(option.price),
                    })}
                  </div>
                </SelectItem>
              ))}
            </Select>

            <CardBox className="flex justify-between items-center">
              <div className="text-body text-sm">{t('currentPlan')}</div>
              {activePlan ? (
                <div className="flex gap-2 font-semibold">
                  {t('planInfo', {
                    name: activePlan.plan_name,
                    duration: activePlan.plan_duration,
                    price: formatMoney(activePlan.plan_price),
                  })}
                </div>
              ) : (
                <div className="flex gap-2 font-semibold">{t('free')}</div>
              )}
            </CardBox>

            <Button onPress={() => handleCreateSubscription(close)} isPending={isPending}>
              {t('confirm')}
            </Button>
          </Stack>
        </>
      )}
    </Dialog>
  );
}

export default SwitchPlanDialog;
